// api 文档 参考: https://2x.ant.design/components/notification-cn/
import * as React from 'react'
import Notification from './Notification'

import { Alert } from 'antd'

import './index.less'

const notificationInstance = {}
let defaultDuration = 4.5
let defaultTop = 70
let defaultBottom = 20
let defaultPlacement = 'topRight'
let defaultGetContainer = () => document.body

function setNotificationConfig(options) {
  const { duration, placement, bottom, top, getContainer } = options
  if (duration !== undefined) {
    defaultDuration = duration
  }
  if (placement !== undefined) {
    defaultPlacement = placement
  }
  if (bottom !== undefined) {
    defaultBottom = bottom
  }
  if (top !== undefined) {
    defaultTop = top
  }
  if (getContainer !== undefined) {
    defaultGetContainer = getContainer
  }
}

function getPlacementStyle(placement) {
  let style
  switch (placement) {
    case 'topLeft':
      style = {
        left: 0,
        top: defaultTop,
        bottom: 'auto',
      }
      break
    case 'topRight':
      style = {
        right: 0,
        top: defaultTop,
        bottom: 'auto',
      }
      break
    case 'bottomLeft':
      style = {
        left: 0,
        top: 'auto',
        bottom: defaultBottom,
      }
      break
    case 'top':
      style = {
        left: '50%',
        top: '20px',
        marginLeft: '-308px',
        width: '616px'
      }
      break
    default:
      style = {
        right: 0,
        top: 'auto',
        bottom: defaultBottom,
      }
      break
  }
  return style
}

function getNotificationInstance(prefixCls, placement, callback) {
  const cacheKey = `${prefixCls}-${placement}`
  if (notificationInstance[cacheKey]) {
    callback(notificationInstance[cacheKey])
    return
  }
  (Notification).newInstance({
    prefixCls,
    className: `${prefixCls}-${placement}`,
    style: getPlacementStyle(placement),
    getContainer: defaultGetContainer,
    closeIcon: <i className={`${prefixCls}-close-icon dmpicon-close-thin`} />,
  }, (notification) => {
    notificationInstance[cacheKey] = notification
    callback(notification)
  })
}

const typeToIcon = {
  success: 'dmpicon-done',
  info: 'dmpicon-tip',
  error: 'dmpicon-add',
  warning: 'dmpicon-help',
}

function notice(args) {
  const outerPrefixCls = args.prefixCls || 'rc-notification'
  const prefixCls = `${outerPrefixCls}-notice`
  const duration = args.duration === undefined ? defaultDuration : args.duration

  let iconNode = null
  if (args.icon) {
    iconNode = (
      <span className={`${prefixCls}-icon`}>
        {args.icon}
      </span>
    )
  } else if (args.type && args.type !== 'alert') {
    const iconType = typeToIcon[args.type]
    iconNode = (
      <i
        className={`${prefixCls}-icon ${prefixCls}-icon-${args.type} ${iconType}`}
      />
    )
  }
  const autoMarginTag = (!args.description && iconNode)
    ? <span className={`${prefixCls}-message-single-line-auto-margin`} />
    : null
  getNotificationInstance(outerPrefixCls, args.placement || defaultPlacement, (notification) => {
    notification.notice({
      content: args.type !== 'alert' ? (
        <div className={iconNode ? `${prefixCls}-with-icon` : ''}>
          {iconNode}
          <div className={`${prefixCls}-message`}>
            {autoMarginTag}
            {args.message}
          </div>
          <div className={`${prefixCls}-description`}>{args.description}</div>
          {args.btn ? <span className={`${prefixCls}-btn`}>{args.btn}</span> : null}
        </div>
      ) : <Alert
        message={args.description}
        type={args.typeName}
        showIcon
      />,
      closable: true,
      onClose: args.onClose,
      key: args.key,
      style: args.style || {},
      className: args.className,
      duration
    })
  })
}

const api = {
  open: notice,
  close(key) {
    Object.keys(notificationInstance)
      .forEach(cacheKey => notificationInstance[cacheKey].removeNotice(key))
  },
  config: setNotificationConfig,
  destroy() {
    Object.keys(notificationInstance).forEach((cacheKey) => {
      notificationInstance[cacheKey].destroy()
      delete notificationInstance[cacheKey]
    })
  },
};
['success', 'info', 'warning', 'error', 'alert'].forEach((type) => {
  api[type] = args => api.open({
    ...args,
    type,
  })
})
api.warn = api.warning

// 参考ant design 2.x版本api: https://2x.ant.design/components/notification-cn/
export default api

// 一般使用法: notifyError('获取报告列表失败', json.msg)
export const notifyError = function (title, description = '', duration = 0) {
  api.error({
    message: title,
    description,
    duration,
  })
}
// 一般使用法: notifySuccess('保存成功')
export const notifySuccess = function (title, description = '', duration = 4.5) {
  api.success({
    message: title,
    description,
    duration,
  })
}

export const notifyInfo = function (title, description = '', duration = 4.5) {
  api.info({
    message: title,
    description,
    duration,
  })
}

export const notifyWarning = function (title, description = '', duration = 4.5) {
  api.warn({
    message: title,
    description,
    duration,
  })
}

/* 更新元数据接口错误提示 */
export const notifyAlert = function (title, description = '', type = 'info', duration = 4.5) {
  api.alert({
    message: title,
    description,
    duration,
    placement: 'top',
    typeName: type
  })
}
